import { Type } from 'class-transformer';
import { FieldType } from 'src/app/settings/model/field-type';
import { ValueField } from 'src/app/settings/model/value-field';
import { Device } from './device';
import { DisplaySynchronization } from './display-synchronization';

export class VehicleDisplaySynchronization {

    @Type(() => DisplaySynchronization)
    synchronization: DisplaySynchronization;

    @Type(() => Device)
    device: Device;

    static getDataSourceName = (): string => 'vehicle-display-synchronization-source';

    static getValueFields(): ValueField[] {
        return [
            Object.assign(new ValueField(), {
                name: FieldType.DEVICE_ID,
                type: FieldType.DEVICE_ID,
                primaryKey: true,
                visible: true,
                jsonpath: '$.device.id'
            }),
            Object.assign(new ValueField(), {
                name: 'deviceType',
                type: FieldType.TEXT,
                visible: true,
                jsonpath: '$.device.deviceType'
            }),
            // TO DO do zmiany gdy aplikacja obslugujaca wersje urzadzen (OTA) bedzie zwracac model urzadzenia
            Object.assign(new ValueField(), {
                name: 'deviceModel',
                type: FieldType.CONST_VALUE,
                visible: true,
                constValue: '42-cale'
            }),
            Object.assign(new ValueField(), {
                name: 'syncTime',
                type: FieldType.DATETIME,
                visible: true,
                canFilter: true,
                jsonpath: '$.synchronization.syncTime'
            })
        ];
    }

}
